import {getApolloClient} from 'graphql-client/ApolloClient';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {StorableSummaryQuery, StorableSummaryQueryVariables} from './__generated/StorableSummaryQuery';
import {STORABLE_SUMMARY_QUERY} from './useSkippableStorableSummaryQuery';

export interface StorableViewAttributes {
  name?: string;
}

export function storableSummaryDataToAttributes(data: StorableSummaryQuery): StorableViewAttributes {
  const node = data.storable;
  if (isInaccessible(node)) {
    return {};
  }
  return {name: node.name};
}

// Prevents Relevant Items tab from "Loading..." when the storable is not in StorableStore.
export function fetchStorableViewAttributes(fileId: string): Promise<StorableViewAttributes> {
  return getApolloClient()
    .query<StorableSummaryQuery, StorableSummaryQueryVariables>({
      query: STORABLE_SUMMARY_QUERY,
      variables: {id: fileId},
    })
    .then((response) => storableSummaryDataToAttributes(response.data))
    .catch(() => ({}));
}
